export const GET_TEST_DEFINITIONS = "GET_TEST_DEFINITIONS"
export const GET_TEST_DEFINITIONS_SUCCESS = "GET_TEST_DEFINITIONS_SUCCESS"

export const ADD_NEW_TEST_DEFINITION = "ADD_NEW_TEST_DEFINITION"
export const ADD_TEST_DEFINITION_SUCCESS = "ADD_TEST_DEFINITION_SUCCESS"

export const UPDATE_TEST_DEFINITION = "UPDATE_TEST_DEFINITION"
export const UPDATE_TEST_DEFINITION_SUCCESS = "UPDATE_TEST_DEFINITION_SUCCESS"

export const DELETE_TEST_DEFINITION = "DELETE_TEST_DEFINITION"
export const DELETE_TEST_DEFINITION_SUCCESS = "DELETE_TEST_DEFINITION_SUCCESS"

export const TEST_DEFINITION_API_ERROR = "TEST_DEFINITION_API_ERROR"